import React, {Fragment, useState} from "react";

import ReactDiffViewer from 'react-diff-viewer';

import client from "../../../services/session/apiClient";

import './ChangeLogBrowser.scss'
import {ProviderImage} from "../../../components";
import PageTitle from "../../../components/typography/PageTitle";

export default function ChangeLogsBrowser ({}) {
  // Search for change logs
  const [entityIdSearch, setEntityIdSearch] = useState("100288020")
  const [usernameSearch, setUsernameSearch] = useState("duffyssportsgrillmaster")
  const [changeLogs, setChangeLogs] = useState([])

  // Search for a location's credentials
  const [locationCredentialsSearch, setLocationCredentialsSearch] = useState("100002244")
  const [locationCredentials, setLocationCredentials] = useState([])


  // For some reason after logs don't have $oid often
  // Remove $oid because it pollutes the logs
  const removeBeforeAndAfterOID = (changeLog) => {
    if (changeLog.change.before && changeLog.change.before[0] && changeLog.change.before[0]._id) {
      delete changeLog.change.before[0]._id
    }
    if (changeLog.change.after && changeLog.change.after[0] && changeLog.change.after[0]._id) {
      delete changeLog.change.after[0]._id
    }

    return changeLog
  }

  // One thing I noticed while working on this is we have a lot of updates with no changes
  // Check location 933854 for an example of this
  const filterChangeLogs = (changeLog) => {
    if (changeLog.change.before && changeLog.change.before[0] && changeLog.change.before[0] &&
      changeLog.change.after && changeLog.change.after[0] && changeLog.change.after[0]
    ) {
      return JSON.stringify(changeLog.change.before) !== JSON.stringify(changeLog.change.after)
    }

    return true
  }

  // Make the change logs more useful before displaying them
  const cleanChangeLog = (changeLog) => {
    return removeBeforeAndAfterOID(changeLog)
  }

  const submitEntitySearch = () => {
    const params = {
      entityId: entityIdSearch
    }

    client.get("/v5/admin/changeLogs", {params})
      .then(resp => resp.data)
      .then(changeLogs => {
        setChangeLogs(changeLogs.map(cleanChangeLog).filter(filterChangeLogs))
      })
  }

  const submitUsernameSearch = () => {
    const params = {
      username: usernameSearch
    }

    client.get("/v5/admin/changeLogs", {params})
      .then(resp => resp.data)
      .then(changeLogs => {
        setChangeLogs(changeLogs.map(cleanChangeLog).filter(filterChangeLogs))
      })
  }

  const submitLocationCredentialsSearch = () => {
    const params = {
      locationId: locationCredentialsSearch
    }

    client.get("/v5/admin/listLocationCredentials", {params})
      .then(resp => resp.data)
      .then(locationCredentials => {
        setLocationCredentials(locationCredentials)
      })
  }

  function JSONStringifyOrder( obj, space )
  {
    var allKeys = [];
    JSON.stringify( obj, function( key, value ){ allKeys.push( key ); return value; } )
    allKeys.sort();
    return JSON.stringify( obj, allKeys, space );
  }

  const getChangeLogTitle = (changeLog) => {
    return (new Date(changeLog.createdAt).toLocaleString()) + " " + changeLog.entityType + " (" + changeLog.entityIds[0] +  ") "  + changeLog.change._type + " by " + (changeLog.username || "Unknown")
  }

  return <div className="changeLogs">
    <label>Search for changes to an Account, Group, Location or User by id : <input
      value={entityIdSearch}
      onChange={e => setEntityIdSearch(e.target.value)}
    /></label>
    <button onClick={submitEntitySearch}>Search</button><br />
    <label>Search for changes made by a user (Username is case-sensitive) : <input
      value={usernameSearch}
      onChange={e => setUsernameSearch(e.target.value)}
    /></label>
    <button onClick={submitUsernameSearch}>Search</button><br />
    Returns Most Recent 50 Changes sorted by Newest to Oldest.
    {changeLogs.map(changeLog => {
      return <Fragment>
        {
          (changeLog.change._type === "Updated") && <ReactDiffViewer
            oldValue={JSONStringifyOrder(changeLog.change.before, '\t')}
            newValue={JSONStringifyOrder(changeLog.change.after, '\t')}
            splitView={true}
            useDarkTheme
            leftTitle={getChangeLogTitle(changeLog)}
          />
        }
        {
          (changeLog.change._type === "Created") && <ReactDiffViewer
            oldValue={JSONStringifyOrder("{}", '\t')}
            newValue={JSONStringifyOrder(changeLog.change.after, '\t')}
            splitView={true}
            useDarkTheme
            leftTitle={getChangeLogTitle(changeLog)}
          />
        }
        {
          (changeLog.change._type === "Deleted") && <ReactDiffViewer
            oldValue={JSONStringifyOrder(changeLog.change.before, '\t')}
            newValue={JSONStringifyOrder("{}", '\t')}
            splitView={true}
            useDarkTheme
            leftTitle={getChangeLogTitle(changeLog)}
          />
        }
      </Fragment>
    })}

    <div style={{"marginTop": "75px"}}>
      <PageTitle>
        Find Credentials Associated With Location
      </PageTitle>
      <label>Search for credentials by a location id : <input
        value={locationCredentialsSearch}
        onChange={e => setLocationCredentialsSearch(e.target.value)}
      /></label>
      <button onClick={submitLocationCredentialsSearch}>Search</button><br />
      <div>
        {locationCredentials.map(listingWithCredentials => {
          return <Fragment>
            {listingWithCredentials.credentials.map(credential => {
              return <div style={{"marginBottom": "20px"}}>
                <ProviderImage
                  provider={listingWithCredentials.listing.contentProvider}
                /> Credential ID: {credential.id}<br />
                Name {credential.remoteAccountName}<br />
                Last Updated {credential.lastUpdated}
              </div>
            })}
          </Fragment>
        })}
      </div>
    </div>
  </div>
}
